export const TRANSLATION_NAMESPACES = {
  AUTH: 'auth',
  COMMON: 'common',
  FOOTER: 'footer',
  COMPONENTS: 'components',
  NAVIGATION: 'navigation',
} as const;
